// @codekit-prepend "js/tinypubsub.js", "js/breakpoints.js", "js/jquery.unveil.js", "js/velocity.js", "js/velocity.ui.js", "js/jquery.touchSwipe.min.js", "js/timers.js", "js/slider.js", "js/parallax.js", "js/jquery.inview.min.js", "js/jquery.doTimeout.min.js", "js/jquery.mixitup.min.js", "js/youtubeplayer.js", "js/gmap-acf.js", "js/odometer.min.js";

/*!
 * Glance Digital Custom JavaScript Programing
 * lance@glance.ca
 *
 */

jQuery(document).ready(function($) {


    // SETTINGS
    // ------------------


    // Lazy Load Background Images
    // ------

    $(".lazy .slide").unveil();
    $('.lazy-img').unveil();


    // Velocty Easing
    // ------

    $.Velocity.defaults.easing = 'easeInOutQuart';



    // PLUGINS
    // ------------------


    // 1. Top Header Nav
    if ($('.site-header').length) {
        $('.site-header').switchNav();
    }


    // 2. Tab Index
    if ($('#tabindex').length) {
        $('#tabindex').tabindex();
    }


    // 3. Banner Image Parallax
    if ($('.parallax').length) {
        $('.parallax').parallax({offsetIntertia: -.2});
    }


    // 4. Slideshow
    if ($('.slideshow').length) {
        $('.slideshow').slideshow({nav_nextprev: '.next_prev span', nav_index: '.index span', speed: 600});
    }


    // 5. Next btn
    if ($('button.next').length) {
        $('button.next').each(function() {
            $(this).scrollToNext({offset_lg: 80, offset_sm: 80});
        });
    }

    
    // 6. Anchor Link Scroll
    $("a[href^='#']").scrollto({offset_lg: 80, offset_sm: 80});


    // 10. Statistics counter
    if ($('.statistics-panel').length) {
        $('.statistics-panel').statisticsCounter();
    }




    // Init Breakpoint Listeners
    // ------------------
    
    $(this).breakpoints();
});




// ------------------------------------------------------------------------------------------------------------------------------------------------
// PLUGINS


(function($) {



    // 1. Top Navigation : toggle mobile and desktop
    // ------

    $.fn.switchNav = function(options) {
        var settings = $.extend( {
            breakpoint : 'atleast_medium'
        }, options);

        var $top = this;
        var nav_desk = null;
        var nav_mobile = null;

        function switchNav(obj, media) {

            // Set Desktop Nav 
            if (media[settings.breakpoint] || media.fallback) {

                if (nav_mobile != null) {
                    nav_mobile.kill();
                    nav_mobile = null;
                }
                if (nav_desk == null) {
                    nav_desk = $top.desktopMenu();
                }

            // Set Mobile Nav 
            } else {

                if (nav_desk != null) {
                    nav_desk.kill();
                    nav_desk = null;
                }
                if (nav_mobile == null) {
                    nav_mobile = $top.mobileMenu();
                }
            }
        }
        $.subscribe("breakpoints", switchNav);
    }


    // 1.a Mobile Menu

    $.fn.mobileMenu = function() {
        var $container = this;
        var $nav = $container.find('#primary');
        var $primaryDropdown = this.find('.hamburger');

        $nav.velocity('slideUp',{duration:0, display:'none'});

        $primaryDropdown.on('click', function(e) {
            e.preventDefault();
            if ($container.hasClass('open')) {
                $primaryDropdown.removeClass('is-active');
                $container.removeClass('open');
                $nav.velocity('slideUp',{duration:600, display:'none'});

            } else {
                $primaryDropdown.addClass('is-active');
                $container.addClass('open');
                $nav.velocity('slideDown',{duration:600, display:'block'});
            }
        });

        // Filter Dropdown
        $('.category-filter h6').each(function() {
            var $toggle = $(this);
            var closed = true;
            $toggle.on('click', function() {
                if (closed) {
                    $toggle.next('ul').velocity('slideDown');
                } else {
                    $toggle.next('ul').velocity('slideUp');
                }
                closed = !closed;
            });
        });

        return {
            kill: function() { 
                $primaryDropdown.off('click').removeClass('is-active');
                $nav.velocity('slideDown',{duration:0, display:'block', complete: function() {
                    $nav.attr('style', '');
                }});
                $('.category-filter').each(function() {
                    $(this).find('h6').off('click');
                    $(this).find('ul').attr('style','');
                });
            }
        };
    }


    // 1.b Desktop Menu

    $.fn.desktopMenu = function(options) {
        var settings = $.extend( {
            trigger_offset : 1
        }, options);

        var $container = this;
        var $window = $(window);
        var scrollTop = $window.scrollTop();
        var min = false;
        var offset = ($window.width() / 16 * settings.trigger_offset) - 1;

        function scrollState() {
            scrollTop = $window.scrollTop();

            // Minimized Top State
            if (scrollTop >= offset && !min) {
                min = true;
                $container.addClass('minimize');

            // Full Top State
            } else if (scrollTop < offset && min) {
                min = false;
                $container.removeClass('minimize');
            }
        }

        $window.on('scroll.menustate', scrollState).on('resize.scrollto', function() {
            offset = ($window.width() / 16 * settings.trigger_offset) - 1;
        });
        scrollState();


        // Kill desktop functionality
        // ------

        return { 
            kill: function() { 
                $container.removeClass('minimize');
                $window.off('scroll.menustate');
            } 
        };
    }





    // 2. Tab Index
    // ------

    $.fn.tabindex = function() {
        var $tab = this;
        var $tab_handle = this.find('h6');
        var $links = $tab.find('a');
        var timeout = setTimeout(function() {
            $tab.addClass('open');
            updateHighlight();
        }, 1200);

        function updateHighlight() {
            $links.removeClass('active').each(function() {
                var $self = $(this);
                var id = $self.attr('href');
                var $el = $(id);
                if (isInFocus($el, .6)) {
                    $links.removeClass('active');
                    $self.addClass('active');
                }
            });
        }

        $(window).on('scroll.tabindex', function() {
            clearTimeout(timeout);
            $tab.removeClass('open').addClass('closed');
        });

        $tab_handle.on('click', function() {
            clearTimeout(timeout);
            if (!$tab.hasClass('open')) {
                $tab.removeClass('closed').addClass('open');
                updateHighlight();
            } else {
                $tab.removeClass('open').addClass('closed');
            }
        });
    }




    

    // 4. Image Gallery Slideshow
    // ------

    $.fn.slideshow = function(options) {
        var settings = $.extend( {
            autoSlide        : 0,
            slides           : '.slide',
            slides_h         : '.slides',
            nav_nextprev     : null,
            nav_index        : null,
            transitionStyle  : 'fade',
            speed            : 300,
            delay            : 0,
            lazy_delay       : 1000
        }, options);
        
        var is_touch_device = 'ontouchstart' in document.documentElement;
        var slideshows = new Array();
        
        this.each(function() {
            var $slideshow = $(this);
            var $slides = $slideshow.find(settings.slides);
            var $nav_index = settings.nav_index == null ? null : $slideshow.find(settings.nav_index);
            var $nav_prev = settings.nav_nextprev == null ? null : $slideshow.find(settings.nav_nextprev + ":first");
            var $nav_next = settings.nav_nextprev == null ? null : $slideshow.find(settings.nav_nextprev + ":last");
            
            var is_lazy = $slideshow.hasClass('lazy');
            var delay = is_lazy ? settings.lazy_delay : settings.delay;
            var autoSlide = typeof $slideshow.find(settings.slides_h).data('autoscroll') != 'undefined' ? $slideshow.find(settings.slides_h).data('autoscroll') : settings.autoSlide;

            // init slideshow
            var slideshow = $slideshow.slider({transitionStyle:settings.transitionStyle, autoSlide:0, transitionDelay:delay, transitionSpeed:settings.speed});
            
            // Highlight Index Nav
            if (settings.nav_index != null) {
                $nav_index.eq(0).addClass('active');
                $slideshow.on('transition_out', function(obj, slide, next, direction) {
                    $nav_index.removeClass('active');
                    var section = next.index();
                    var $sel = $nav_index.eq(section);
                    $sel.addClass('active');

                    if (is_lazy) next.trigger("unveil"); // Lazy load next slide
                });

            } else if (is_lazy) {
                $slideshow.on('transition_out', function(obj, slide, next, direction) {
                    next.trigger("unveil");  // Lazy load next slide
                });
            }

            // Only run autoSlide while slideshow is in view
            slideshow.next();
            $slideshow.on('inview', function(event, isInView) {
                if (isInView) {
                    if (autoSlide > 0) {
                        slideshow.start(autoSlide);
                    }
                } else {
                    slideshow.stop();
                }
            });
            

            // No sliding with less than 2 slides
            if ($slides.length < 2) {
                
                $slideshow.addClass('empty');
                
            } else {
                
                // Swipe scroll
                if (is_touch_device) {

                    $slideshow.swipe({
                        allowPageScroll: 'vertical',
                        swipe:function(event, direction, distance, duration, fingerCount) {
                            if (direction == 'right') {
                                slideshow.back();

                            } else if (direction == 'left') {
                                slideshow.next();
                            }
                        }
                    });

                }

                // Index Icon navigate
                if (settings.nav_index != null) {
                    $nav_index.on('click', function(e) {
                        e.preventDefault();
                        slideshow.at($(this).index());
                    });
                }

                // Next / Prev navigate
                if (settings.nav_nextprev != null) {
                    
                    $nav_prev.on('click', function(e) {
                        e.preventDefault();
                        slideshow.back();
                    });

                    $nav_next.on('click', function(e) {
                        e.preventDefault();
                        slideshow.next();
                    });
                }
            
            }

            slideshows.push({el: $slideshow, obj: slideshow});
        });
        
        return slideshows;
    }




    // 5. Scroll to next
    // ------

    $.fn.scrollToNext = function(options) {
        var settings = $.extend( {
            offset_lg : 0,
            offset_sm : 0
        }, options);
        var offset = settings.offset_lg;

        this.on('click', function(event) {
            var $el = $(this).parent().next();
            event.preventDefault();

            var top = $el.offset().top - offset;
            $('html').velocity('scroll', {duration: 900, offset: top});
        });
        
        $.subscribe("breakpoints", function(obj, media) {
            offset = media.small ? settings.offset_sm : settings.offset_lg;
        });

        return this;
    }





    // 6. Anchor scroll
    // ------

    $.fn.scrollto = function(options) {
        var settings = $.extend( {
            offset_lg : 0,
            offset_sm : 0
        }, options);
        var offset = settings.offset_lg;

        this.on('click', function(event) {
            var id = $(this).attr('href').split('#')[1];
            
            if ($('#'+id).length) {
                event.preventDefault();

                var $el = $('#'+id);
                var top = id == 'top' ? $el.offset().top : $el.offset().top - offset;
                $('html').velocity('scroll', {duration: 900, offset: top});
            }
        });
        
        $.subscribe("breakpoints", function(obj, media) {
            offset = media.small ? settings.offset_sm : settings.offset_lg;
        });

        return this;
    }




    // 10. Statistics Counter
    // ------
    $.fn.statisticsCounter = function() {

        this.each(function() {
            var $this = $(this);
            var $nums = $this.find('.statistic_number');
            var first = true;

            $this.on('inview', function(event, isInView) {
                if (first && isInView) {
                    first = false;
                    var i = 0;
                    $nums.each(function() {
                        var $num = $(this);
                        setTimeout(function() {
                            $num.html($num.data('value'));    
                        }, i * 1200);
                        i++;
                    });
                }
            });
        });

        return this;
    }



    // Utilities
    // ------

    var aboveView = function(element) {
        return $(window).scrollTop() >= element.offset().top + element.outerHeight();
    }

    var belowFocus = function(element, focusMultipliers) {
        return $(window).height() + $(window).scrollTop() < element.offset().top + $(window).height() * focusMultipliers;
    }
    
    var isInFocus = function(element, focusMultipliers) {
        return (aboveView(element)!=true && belowFocus(element, focusMultipliers)!=true);
    }

})(jQuery);